import { dogBreeds } from '../data/breeds.js';

// Static mapping of breed names (lowercased) to their image URLs
const BREED_IMAGES = {
  "airedale terrier": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Airedale%20Terrier.jpg",
  "akita": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Akita.jpg",
  "american staffordshire terrier": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/American%20Staffordshire%20Terrier.jpg",
  "australian cattle dog": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Australian%20Cattle%20Dog.jpg",
  "australian shepherd": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Australian%20Shepherd.jpg",
  "basset hound": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Basset%20Hound.jpg",
  "beagle": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Beagle.jpg",
  "bernese mountain dog": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Bernese%20Mountain%20Dog.jpg",
  "bichon frise": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Bichon%20Frise.jpg",
  "bloodhound": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Bloodhound.jpg",
  "border collie": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Border%20Collie.jpg",
  "border terrier": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Border%20Terrier.jpg",
  "borzoi": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Borzoi.jpg",
  "boston terrier": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Boston%20Terrier.jpg",
  "boxer": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Boxer.jpg",
  "brittany": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Brittany.jpg",
  "brussels griffon": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Brussels%20Griffon.jpg",
  "bull terrier": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Bull%20Terrier.jpg",
  "bulldog": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Bulldog.jpg",
  "cairn terrier": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Cairn%20Terrier.jpg",
  "cardigan welsh corgi": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Cardigan%20Welsh%20Corgi.jpg",
  "cavalier king charles spaniel": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Cavalier%20King%20Charles%20Spaniel.jpg",
  "chihuahua": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Chihuahua.jpg",
  "chow chow": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Chow%20Chow.jpg",
  "cockapoo": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Cockapoo.jpg",
  "cocker spaniel": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Cocker%20Spaniel.jpg",
  "collie": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Collie.jpg",
  "dachshund": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Dachshund.jpg",
  "dalmatian": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Dalmatian.jpg",
  "doberman pinscher": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Doberman%20Pinscher.jpg",
  "english setter": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/English%20Setter.jpg",
  "english springer spaniel": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/English%20Springer%20Spaniel.jpg",
  "french bulldog": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/French%20Bulldog.jpg",
  "german shepherd": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/German%20Shepherd.jpg",
  "german shorthaired pointer": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/German%20Shorthaired%20Pointer.jpg",
  "golden retriever": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Golden%20Retriever.jpg",
  "goldendoodle": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Goldendoodle.jpg",
  "great dane": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Great%20Dane.jpg",
  "greyhound": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Greyhound.jpg",
  "irish wolfhound": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Irish%20Wolfhound.jpg",
  "jack russell terrier": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Jack%20Russell%20Terrier.jpg",
  "labradoodle": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Labradoodle.jpg",
  "labrador retriever": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Labrador%20Retriever.jpg",
  "maltese": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Maltese.jpg",
  "maltipoo": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Maltipoo.jpg",
  "newfoundland": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Newfoundland.jpg",
  "papillon": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Papillon.jpg",
  "pembroke welsh corgi": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Pembroke%20Welsh%20Corgi.jpg",
  "pointer": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Pointer.jpg",
  "pomeranian": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Pomeranian.jpg",
  "pug": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Pug.jpg",
  "puggle": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Puggle.jpg",
  "rhodesian ridgeback": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Rhodesian%20Ridgeback.jpg",
  "rottweiler": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Rottweiler.jpg",
  "saint bernard": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Saint%20Bernard.jpg",
  "scottish terrier": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Scottish%20Terrier.jpg",
  "shetland sheepdog": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Shetland%20Sheepdog.jpg",
  "shiba inu": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Shiba%20Inu.jpg",
  "shih tzu": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Shih%20Tzu.jpg",
  "siberian husky": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Siberian%20Husky.jpg",
  "standard poodle": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Standard%20Poodle.jpg",
  "vizsla": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Vizsla.jpg",
  "weimaraner": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Weimaraner.jpg",
  "west highland white terrier": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/West%20Highland%20White%20Terrier.jpg",
  "whippet": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Whippet.jpg",
  "yorkshire terrier": "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate%20Photos/Yorkshire%20Terrier.jpg"
};

class ImageService {
  constructor() {
    this.defaultImage = 'FetchMate_Hero.png';
  }

  /**
   * Get a photo for a specific breed ID using the static mapping.
   * @param {string} breedId - The unique ID of the breed
   * @returns {Promise<Object>} - Photo object
   */
  async getBreedPhoto(breedId) {
    try {
      const breed = dogBreeds.find(b => b.id === breedId);
      
      if (!breed) {
        console.warn(`ImageService: Breed ID "${breedId}" not found in database.`);
        return this.getDefaultPhoto();
      }

      // Look up by normalized name in the static map
      const breedName = breed.name.toLowerCase();
      const imageUrl = BREED_IMAGES[breedName];

      if (imageUrl) {
        return {
          url: imageUrl,
          medium: imageUrl,
          small: imageUrl,
          photographer: 'FetchMate Gallery',
          alt: breed.name
        };
      }

      console.warn(`ImageService: No image found for "${breedName}" in static map.`);
      return this.getDefaultPhoto(breed.name);
    } catch (e) {
      console.error('ImageService: Exception in getBreedPhoto', e);
      return this.getDefaultPhoto();
    }
  }

  getDefaultPhoto(altText = 'Dog Photo Placeholder') {
    return {
      url: this.defaultImage,
      medium: this.defaultImage,
      small: this.defaultImage,
      photographer: 'FetchMate',
      alt: altText
    };
  }
}

export const imageService = new ImageService();